import { render, staticRenderFns } from "./NflTeamStack.vue?vue&type=template&id=6d615851&scoped=true"
import script from "./NflTeamStack.vue?vue&type=script&lang=js"
export * from "./NflTeamStack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d615851",
  null
  
)

export default component.exports